import { Button } from '@/components/ui/button';
import SessionTemplateSelectorDialog from './SessionTemplateSelectorDialog';
import type { SessionTemplate } from '@arrowise/shared';
import { Circle, CircleCheck } from 'lucide-react';

export interface TemplateSelectorProps {
    selectedTemplate: SessionTemplate | null;
    onTemplateSelect: (template: SessionTemplate | null) => void;
    teamId?: string | null;
    dialogOpen: boolean;
    onDialogOpenChange: (open: boolean) => void;
    isManage: boolean;
}

export function TemplateSelector({
    selectedTemplate,
    onTemplateSelect,
    teamId = null,
    dialogOpen,
    onDialogOpenChange,
    isManage,
}: TemplateSelectorProps) {
    return (
        <>
            <div className="mb-4 flex items-center space-x-2">
                <Button onClick={() => onDialogOpenChange(true)} size="sm" type="button">
                    {isManage ? 'Change Template' : 'Select Template'}
                </Button>
                {selectedTemplate ? <CircleCheck color='green' /> : <Circle />}
            </div>

            <SessionTemplateSelectorDialog
                open={dialogOpen}
                onOpenChange={onDialogOpenChange}
                selectedTemplateId={selectedTemplate?.id || null}
                teamId={teamId}
                onConfirm={onTemplateSelect}
            />
        </>
    );
}
